import React, { useState } from 'react';
import { Heart } from 'lucide-react';
import ModalTerms from '../shared/ModalTerms';  // IMPORTANTE

const Hero = () => {
  const [openModal, setOpenModal] = useState(false);

  const handleAccept = () => {
    setOpenModal(false);
    window.location.href = "/formulario"; // Redirigir al formulario
  };

  return (
    <>
      <section className="bg-white from-blue-50 to-white py-16 md:py-24">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-3xl mx-auto text-center">

            <div className="inline-flex items-center justify-center mb-6">
              <Heart className="w-10 h-10 text-purple-500 animate-pulse" />
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-blue-800 mb-6">
              Comprendiendo el Autismo
            </h1>

            <p className="text-lg md:text-xl text-gray-700 mb-4">
              El Trastorno del Espectro Autista (TEA) afecta la forma...
            </p>

            <p className="text-xl md:text-2xl text-purple-600 font-semibold mb-8">
              ¿Deseas conocer si tu hijo presenta riesgo de tener TEA?
            </p>

            <button
              onClick={() => setOpenModal(true)}
              className="inline-block rounded-full bg-blue-600 px-8 py-4 text-lg text-white hover:bg-blue-500 transition-all shadow-md hover:shadow-lg"
            >
              Iniciar Prueba
            </button>

          </div>
        </div>
      </section>

      {/* MODAL DE TÉRMINOS */}
      <ModalTerms 
        open={openModal} 
        onAccept={handleAccept} 
        onClose={() => setOpenModal(false)} 
      />
    </>
  );
};

export default Hero;
